import { Component, OnInit } from '@angular/core';
import { ComunicadosService } from '../comunicados.service';

@Component({
  selector: 'app-mayoristas-comunicados-finanzas',
  templateUrl: './mayoristas-comunicados-finanzas.component.html',
  styleUrls: [
  	'./mayoristas-comunicados-finanzas.component.css',
  	'../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss',
  ]
})
export class MayoristasComunicadosFinanzasComponent implements OnInit {
  public comunicados;
  constructor(private comunicadosService: ComunicadosService) { }

  ngOnInit() {
    this.comunicadosService.getAllComunicadosbyCategory('Finanzas')
      .then(response => {
        this.comunicados = response;
      })
      .catch(err => console.error(err));
  }


}
